<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" max-width="600px" @keydown="checkEsc">
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{
                `${$t('workPlan.titleFrom')} ${startDate} ${$t(
                  'workPlan.titleTo'
                )} ${endDate}`
              }}
            </span>
          </v-card-title>
          <div class="Absolute-Center" v-if="workPlan.length === 0">
            <spinner></spinner>
          </div>
          <v-card-text>
            <div v-for="(itemDate, indexDate) in workPlan" :key="indexDate">
              <div>
                <div
                  @click="
                    currentDate === itemDate.rowName
                      ? (currentDate = '')
                      : (currentDate = itemDate.rowName)
                  "
                  class="d-flex flex-row accordion-row"
                  v-bind:class="{
                    'active-row': currentDate === itemDate.rowName,
                  }"
                >
                  <div class="d-flex flex-grow-0">
                    <v-avatar
                      v-if="itemDate.rowList.length === 0"
                      size="25px"
                      tile
                    >
                      <i aria-hidden="true" class="v-icon material-icons"
                        >highlight_off</i
                      >
                    </v-avatar>
                    <v-avatar
                      v-if="
                        currentDate !== itemDate.rowName &&
                          itemDate.rowList.length !== 0
                      "
                      size="25px"
                      tile
                    >
                      <i aria-hidden="true" class="v-icon material-icons"
                        >add</i
                      >
                    </v-avatar>
                    <v-avatar
                      v-if="
                        currentDate === itemDate.rowName &&
                          itemDate.rowList.length !== 0
                      "
                      size="25px"
                      tile
                    >
                      <i aria-hidden="true" class="v-icon material-icons"
                        >remove</i
                      >
                    </v-avatar>
                  </div>
                  <div class="date-txt-holder">
                    <h5>{{ itemDate.rowName }}</h5>
                  </div>
                </div>
                <div v-if="currentDate === itemDate.rowName">
                  <div v-if="multiPosts">
                    <div v-for="post in posts" :key="post.name">
                      <h5 class="post-title">{{ post.name }}</h5>
                      <div v-for="(docData, i) in post.data" :key="i">
                        <date-details :data="docData" :workPlan="workPlan" />
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    v-for="(itemAuto, indexAuto) in itemDate.rowList"
                    :key="indexAuto"
                  >
                    <date-details :data="itemAuto" :workPlan="workPlan" />
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false">{{ $t('global.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from '@/services/axios'
import i18n from '@/plugins/i18n'

export default {
  name: 'workPlan',
  data: () => ({
    dialog: false,
    workPlan: [],
    currentDate: '',
    startDate: '   -   ',
    endDate: '   -   ',
    showActiveStatus: false,
    posts: [],
  }),
  components: {
    spinner: () => import('./Spinner.vue'),
    DateDetails: () => import('./WorkPlanParts/DateDetails'),
  },
  methods: {
    //'setRowStatus', 'startWorks', 'stopWorks', func in WorkPlanFunctionsMixin.js
    show() {
      this.fetchData()
      setInterval(() => {
        this.showActiveStatus = !this.showActiveStatus
      }, 1000)
      this.$nextTick(() => {
        this.dialog = true
      })
    },
    postRecords(post) {
      const containsPost = (node, post) => {
        if (node.rowList && node.rowList.length) {
          return node.rowList.reduce((a, e) => {
            a = a || containsPost(e, post)
            return a
          }, false)
        } else {
          return node.post === post
        }
      }

      const records = this.workPlan
        .filter(e => e.rowName === this.currentDate)
        .reduce((a, e) => {
          e.rowList.map(rl => {
            if (containsPost(rl, post)) {
              a.push(rl)
            }
          })
          return a
        }, [])
      return records
    },
    fetchData() {
      this.workPlan = []
      axios
        .request({
          url: '/WorkPlan',
          params: {},
        })
        .then(resp => {
          let workPlanErr = 0
          this.workPlan = resp.data.userWorkPlan
          this.startDate = resp.data.startDate
          this.endDate = resp.data.endDate
          if (this.workPlan.length === 0 && workPlanErr === 0) {
            let message = this.workPlanTexts.workPlanIsEmpty
            this.$store.dispatch('showSnackMessage', {
              color: 'error',
              text: message,
            })
            this.dialog = false
          }
        })
        .catch(e => {
          this.$store.dispatch('showSnackMessage', {
            color: 'error',
            text: JSON.stringify(e),
          })
          this.dialog = false
        })
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        this.dialog = false
      }
    },
  },
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    workPlanTexts: function() {
      return i18n.messages[i18n.locale].workPlan
    },
    multiPosts() {
      return this.posts.length
    },
  },
  watch: {
    currentDate(val) {
      if (!val) {
        return
      }
      const curData = this.workPlan.find(e => e.rowName === val)
      if (curData && curData.posts) {
        this.posts = curData.posts.sort((a, b) => {
          return a.name > b.name ? 1 : -1
        })
      } else {
        this.posts = []
      }
    },
  },
}
</script>

<style scoped lang="scss">
.post-title {
  margin-top: 10px;
  border-bottom: 1px dashed #fff;
}
/deep/ .v-card__text {
  max-height: 70vh;
  overflow: auto;
}
/deep/ table.v-table tbody td {
  height: 30px;
}
</style>
